











import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Models
import Item from '@/models/Item'

// Mixins
import ItemsMixins from '@/mixins/Items'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'

// Views
// TODO move from boxes since is not a box anymore
import ItemCategoriesBox from '@/views/all/boxes/ItemCategoriesBox.vue'
import CreateItemModal from '@/views/items/partials/CreateItemModal.vue'
import ImportItemModal from '@/views/items/partials/ImportItemModal.vue'

const modals = {
  new : CreateItemModal,
  csv : ImportItemModal
}

@Component({
  components: { ModalWrapper, ItemCategoriesBox }
})
export default class ItemTopControls extends Mixins(ItemsMixins) {
  datas = null

  @Watch('datas')
  triggerCreationModal(datas) {
    this.$modal.open({
      parent: this,
      component: modals[datas.from],
      props: {
        datas
      }
    })
  }

  updateCategoriesData(datas) {
    this.showCategoryModal = false
    this.datas = {...datas, from: this.from }
  }
}

